// Dependencias.
import Vue from 'vue';
import axios from 'axios';

// Estado inicial
const initialState = () => ({
  listarCampanhas: {
    retorno: null,
    erro: null,
    carregando: false,
  },
});

// Objeto de estado
const state = initialState();

// Getters
const getters = {
  getStateListarCampanhas(state) {
    return state.listarCampanhas;
  },
};

// Ações
const actions = {
  clearState({ commit }) {
    commit('RESET');
  },

  listCampaigns({ commit }, { baseUrl}) {
    return new Promise(async (resolve) => {
      commit('setStateListarCampanhas', { carregando: true, erro: null, retorno: null });

      let optionsAxios = { baseURL: baseUrl, timeout: 15000 };
      let a = axios.create(optionsAxios);

      let optionsReq = {
        method: 'GET',
        url: `${baseUrl}/campanha/v1/campanhas`,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        timeout: 15000,
      };
      
      try {
        const res = await a(optionsReq);
        
        if ([200].includes(res.status)) {
          commit('setStateListarCampanhas', { retorno: res.data.retorno });

          resolve({
            status: 200,
            msg: 'Campanhas retornadas com sucesso',
            retorno: res.data.retorno,
          });
        } else {
          commit('setStateListarCampanhas', {
            retorno: [],
            erro:
              res.data.mensagem ||
              res.data.message ||
              'Erro desconhecido ao listar campanhas, por favor tente novamente',
          });

          resolve({
            status: res.status || 500,
            msg:
              res.data.mensagem ||
              res.data.message ||
              'Erro desconhecido ao listar campanhas, por favor tente novamente',
          });
        }
      } catch (error) {
        commit('setStateListarCampanhas', {
          retorno: [],
          erro: error.message,
        });

        resolve({
          status: 500,
          msg: error.message,
        });
      }

      commit('setStateListarCampanhas', { carregando: false });
    });
  },
};

// Mutações
const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },

  setStateListarCampanhas(state, { retorno, erro, carregando }) {
    state.listarCampanhas.retorno = retorno === undefined ? state.listarCampanhas.retorno : retorno;
    state.listarCampanhas.erro = erro === undefined ? state.listarCampanhas.erro : erro;
    state.listarCampanhas.carregando = carregando === undefined ? state.listarCampanhas.carregando : carregando;
  },
};

// Exoprtanto módulo
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
